import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

export const CompletedFormsShow = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to the new view
    navigate(`/completed-forms/${id}/show`);
  }, [id, navigate]);

  return null;
};


